import { QueryClient } from "@tanstack/react-query";
import { createRouter } from "@tanstack/react-router";
import { routeTree } from "./routeTree.gen";

export const getRouter = () => {
  const queryClient = new QueryClient();

  const router = createRouter({
    routeTree,
    context: { queryClient },
    scrollRestoration: true,
    defaultPreloadStaleTime: 0,
    trailingSlash: 'never',
    defaultNotFoundComponent: () => {
      // Fallback redirect if something really goes wrong with routing
      window.location.href = '/';
      return null;
    },
  });

  return router;
};
